// base_info_view_5_1 
import React, { } from 'react'
import BaseCardView1 from './base_card_view_1'
import { Button, Row, Col, LucideIcon } from './ot'
import {
    Eye,
    MousePointer,
    FileText,
    TrendingUp,
    Edit, Share, Download, Search
} from "lucide-react"

const BaseInfoView5_1 = ({
    rowKey = 'key',
    data = [
        {
            key: "1",
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />
                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },
        {
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },
        {
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },
        {
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },
        {
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        },
        {
            baseCardView1_1Props: {
                checked: false,
                onCheckedChange: () => { }
            },
            baseCardView1_2Props: {
                src: "https://cdn.cybassets.com/s/files/18098/ckeditor/pictures/content_c07533a8-24bd-4af6-b8ed-ba3912ff2f1c.jpg"
            },
            baseCardView1_3Props: {
                value: "Facebook / 產品介紹 / 推薦文 / 精簡版",
            },
            baseCardView1_4Props: {
                value: "元件項目：標題、主文內容、圖片、按鈕、Hashtag",
            },
            baseCardView1_5Props: {
                stats: [
                    {
                        value: 1250,
                        label: "瀏覽次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <Eye className="h-4 w-4 text-blue-500" />
                    },
                    {
                        value: 45,
                        label: "撰寫文案",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <FileText className="h-4 w-4 text-green-500" />


                    },
                    {
                        value: 320,
                        label: "點擊次數",
                        backgroundColor: "bg-blue-50",
                        animationDuration: 2000,
                        animationDelay: 0,
                        icon: <MousePointer className="h-4 w-4 text-purple-500" />

                    },
                    {
                        value: 28,
                        label: "複製次數",
                        backgroundColor: "bg-green-50",
                        animationDuration: 1500,
                        animationDelay: 200,
                        icon: <TrendingUp className="h-4 w-4 text-orange-500" />

                    },
                ]
            },
            baseCardView1_6Props: {
                badges: [
                    {
                        label: "王小明",
                        variant: "outline",
                        className: ""
                    },
                    {
                        label: <><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                            <path d="M8 11h8" />
                            <path d="M8 15h8" />
                            <path d="M8 7h8" />
                        </svg>2025-05-30</>,
                        variant: "outline",
                        className: ""
                    },
                ]
            },
            baseCardView1_7Props: {
                children: <p className="text-gray-600 mt-1 text-sm">儲存位置12w23：.../.../...</p>
            },
            baseCardView1_8Props: {
                buttons: [
                    <Button variant="outline" className="flex-1">
                        <Eye className="h-4 w-4 mr-1" />
                        查看
                    </Button>,
                    <Button className="flex-1">
                        <Edit className="h-4 w-4 mr-1" />
                        複製文案內容並編輯
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Share className="h-4 w-4 mr-1" />
                        分享
                    </Button>,
                    <Button variant="ghost" size="sm">
                        <Download className="h-4 w-4 mr-1" />
                        匯出
                    </Button>,
                    <Button variant="ghost" size="sm" className="text-red-600">
                        刪除
                    </Button>,
                ],
                buttonGroupsColumnsCount: [2, 3],
            },
        }
    ],
    onBaseCardView1CheckChange = () => {

    },
    baseCardView1ShowComponent = [
        "BaseCardView1_1",
        "BaseCardView1_2",
        "BaseCardView1_3",
        "BaseCardView1_4",
        "BaseCardView1_5",
        "BaseCardView1_6",
        "BaseCardView1_7",
        "BaseCardView1_8",
    ],
    total = data?.length,
    onPageChange = () => { }
}) => {

    const dataToBaseCardView1Props = (data) => {
        let newData = (data || []).map((value) => {
            return {
                ...value,
                baseCardView1_1Props: {
                    ...value?.baseCardView1_1Props,
                    onCheckedChange: (checked) => onBaseCardView1CheckChange(checked, value)
                }
            }
        })
        return newData
    }
    return (<Row>
        <Col span={24}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {dataToBaseCardView1Props(data).map((baseCardView1Value) => {
                    return <BaseCardView1
                        showComponent={baseCardView1ShowComponent}
                        {...baseCardView1Value}
                    />
                })}

            </div>
            {/* 無結果提示 */}
            {dataToBaseCardView1Props(data).length === 0 && (
                <div className="text-center py-12">
                    <div className="text-gray-400 mb-2">
                        <LucideIcon name={"Search"} className="h-12 w-12 mx-auto" />

                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">找不到相關內容</h3>
                    <p className="text-gray-500">請嘗試調整搜索關鍵字或篩選條件</p>
                </div>
            )}
        </Col>
    </Row>



    )
}
export default BaseInfoView5_1
